export const PINCODE_ICONS = [
  'circle-dot',
  'tree-christmas',
  'egg',
  'crown',
  'snowflake',
  'futbol',
  'sun',
  'leaf',
  'jack-o-lantern'
] as const

export type PincodeIconName = (typeof PINCODE_ICONS)[number]

export const DEFAULT_PINCODE_ICON: PincodeIconName = 'circle-dot'

export const isPincodeIconName = (
  value?: string | null
): value is PincodeIconName => (
  !!value && PINCODE_ICONS.includes(value as PincodeIconName)
)

export const normalizePincodeIconName = (
  value?: string | null
): PincodeIconName => (
  isPincodeIconName(value) ? value : DEFAULT_PINCODE_ICON
)
